<div class="container mb-2" style="min-height: 50rem">
    <div class="d-flex flex-column flex-md-row gap-4 col-12 mt-2">
        <div class="d-flex flex-column gap-4 col-12 col-md-4 col-lg-2">
            <div class="border border-dark p-4 rounded">
                <h4 class="mb-3">{{ 'strava.webhook_search' | translate }}</h4>
                <form (ngSubmit)="onSearch()" [formGroup]="form">
                    <div class="mb-3">
                        <label class="col-form-label">{{ 'common.search_term' | translate }}</label>
                        <input type="text" formControlName="propertyValue" id="propertyValue" class="form-control" [placeholder]="'common.enter_search_term' | translate" />
                    </div>

                    <div class="mb-3">
                        <label class="col-form-label">{{ 'strava.webhook_modified_range' | translate }}</label>
                        <div class="modified-range-picker">
                            <input bsDaterangepicker
                                [bsConfig]="{ isAnimated: true, rangeInputFormat: 'MM/DD/YYYY', displayMonths: 1, adaptivePosition: true, allowedPositions: ['bottom'] }"
                                placement="bottom"
                                container=".modified-range-picker"
                                placeholder="MM/DD/YYYY - MM/DD/YYYY" type="text" formControlName="modifiedRange" id="modifiedRange" class="form-control" />
                        </div>
                    </div>



                    <div class="mb-3">
                        <label class="col-form-label">{{ 'strava.webhook_status_list' | translate }}</label>
                        <ng-multiselect-dropdown formControlName="stravaWebhookStatusList" id="stravaWebhookStatusList" [placeholder]="'common.please_select' | translate" [settings]="dropdownSettings" [data]="stravaWebhookStatusList"> </ng-multiselect-dropdown>
                    </div>

                    <div class="d-flex justify-content-end gap-2">
                        <button type="button" class="btn btn-outline-secondary search-btn" (click)="onClear()" *ngIf="form.dirty">
                            <i class="bi bi-x-circle"></i>
                            <span class="mx-1">{{ 'common.clear' | translate }}</span>
                        </button>
                        <button type="submit" class="btn btn-outline-secondary search-btn">
                            <i class="bi bi-search"></i>
                            <span class="mx-1">{{ 'common.search' | translate }}</span>
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <div class="col-12 col-md-8 col-lg-10">
            <table *ngIf="showTable" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="row-border hover" style="width: 100%"></table>
        </div>
    </div>

    <ng-template #actionsRef let-data="adtData" let-emitter="captureEvents">
        <app-retry-view [data]="data" (emitter)="emitter($event)"></app-retry-view>
    </ng-template>
</div>
